import React, { useState, useEffect } from "react";
import { Grid, Button } from "@mui/material";
import PlumberCard from "../PlumberCard";
import "./style.css";

export default function JobDetailsFun(props) {
  const [jobDetails, setJobDetails] = useState({
    jobCategory: "",
    service: "",
    isEmergency: false,
    date: "",
    time: "",
    recurringIssue: false,
    scheduledTime: "", // Assuming this holds the combined date and time
  });

  // Fetch job details from localStorage when the component mounts
  useEffect(() => {
    const savedJobDetails = JSON.parse(localStorage.getItem("jobDetails"));
    if (savedJobDetails) {
      setJobDetails(savedJobDetails);
    }
  }, []);

  // Event handler for cancel button
  const handleCancel = () => {
    console.log("Cancel button clicked");
    // Add cancel functionality here
  };

  // Event handler for reschedule button
  const handleReschedule = () => {
    console.log("Reschedule button clicked");
    // Add reschedule functionality here
  };

  // Format the scheduledTime if needed (for example, to display in a readable format)
  const formatScheduledTime = (dateTime) => {
    if (!dateTime) return "";
    const date = new Date(dateTime);
    return date.toLocaleString(); // or any specific format you prefer
  };

  return (
    <Grid container padding="3%">
      <Grid container>
       

        {props.showPlumberCard && (
          <Grid>
            <PlumberCard />
          </Grid>
        )}

      </Grid>
    </Grid>
  );
}
